/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_Proxy_RtInputs */

const en_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const fr_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const de_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const it_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const ru_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прокси RT`)
};

const es_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const zh_cn2_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理RT`)
};

const ja_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシRT`)
};

const hi_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी आरटी`)
};

const pt_pt2_new_project_media_source_proxy_rt = /** @type {(inputs: New_Project_Media_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RT por procuração`)
};

/**
* | output |
* | --- |
* | "Proxy RT" |
*
* @param {New_Project_Media_Source_Proxy_RtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_proxy_rt = /** @type {((inputs?: New_Project_Media_Source_Proxy_RtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_Proxy_RtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_source_proxy_rt(inputs)
	if (locale === "de") return de_new_project_media_source_proxy_rt(inputs)
	if (locale === "it") return it_new_project_media_source_proxy_rt(inputs)
	if (locale === "ru") return ru_new_project_media_source_proxy_rt(inputs)
	if (locale === "es") return es_new_project_media_source_proxy_rt(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_source_proxy_rt(inputs)
	if (locale === "ja") return ja_new_project_media_source_proxy_rt(inputs)
	if (locale === "hi") return hi_new_project_media_source_proxy_rt(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_source_proxy_rt(inputs)
	return en_new_project_media_source_proxy_rt(inputs)
});